class NotificationData {
    value: string;
    title: string;
    type: 'neutral' | 'neutralSmall' | 'success' | 'successSmall' | 'info' | 'infoSmall' | 'error' | 'errorSmall';

    constructor(value: string, title: string, type: 'neutral' | 'neutralSmall' | 'success' | 'successSmall' | 'info' | 'infoSmall' | 'error' | 'errorSmall') {
        this.value = value;
        this.type = type;
        this.title = title;
    }
}

export default NotificationData;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/NotificationData.tsx